import React, { useMemo } from 'react';
import { Spin, List, Row, Col, Switch, Space, Typography, Form } from 'antd';
import Button from 'app/components/Button';
import { EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import classes from './TemplateForm.module.less';
import WithModal from 'app/components/Modal/WithModal';
import CriteriaForm from './Form';

enum TemplateEditMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view'
}

interface IContext {
  readonly?: boolean;
}

interface IProps {
  templateId?: string;
  scheme: string;
  mode: TemplateEditMode;
}

interface ISection {
  name: string;
  enabled: boolean;
  value: string;
  fields: unknown[];
}

const CriteriaFormModal = WithModal(CriteriaForm);

const TemplateFormContext = React.createContext<IContext>({});

const TemplateForm: React.FC<IProps> = (props) => {
  const { templateId, scheme, mode } = props;
  //TODO: Implement the logic for fetch the template by id
  const parsedScheme = useMemo(() => {
    if (!scheme) return [];
    return JSON.parse(scheme);
  }, [scheme]);

  const readonly = mode === TemplateEditMode.VIEW ? true : false;

  if (!scheme) {
    return <Spin spinning />;
  }
  return (
    <TemplateFormContext.Provider
      value={{
        readonly
      }}
    >
      <Form initialValues={{ scheme: parsedScheme }}>
        <Form.List name="scheme">
          {() => {
            return (
              <List
                className={classes.criteria}
                dataSource={parsedScheme}
                rowKey={(record: ISection) => {
                  if (record) return record.name;
                }}
                split={false}
                header={
                  <Typography.Title level={5}>Criteria:</Typography.Title>
                }
                renderItem={(record: ISection, index) => {
                  return (
                    <List.Item>
                      <List.Item.Meta
                        title={`# ${index + 1}`}
                        description={
                          <Row gutter={[16, 16]}>
                            <Col span={3}>
                              <Switch
                                disabled={readonly}
                                checked={record.enabled}
                              />
                            </Col>
                            <Col span={17}>
                              <Row gutter={[16, 16]}>
                                <Col span={16} className={classes.label}>
                                  Name of Sections
                                </Col>
                                <Col span={8} className={classes.label}>
                                  Content Field
                                </Col>
                              </Row>
                              <Row gutter={[16, 16]}>
                                <Col span={16}>
                                  <span className={classes.legend}>
                                    {record.value}
                                  </span>
                                </Col>
                                <Col span={8}>
                                  <span className={classes.legend}>
                                    {record.fields.length}
                                  </span>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={4}>
                              <div className={classes.actions}>
                                <Button
                                  hidden={readonly}
                                  icon={<EditOutlined />}
                                  type="text"
                                ></Button>
                                <CriteriaFormModal
                                  title={record.value}
                                  criteria={record}
                                  readonly={readonly}
                                  width={1100}
                                  footer={null}
                                  triggerElement={
                                    <Button
                                      hidden={!readonly}
                                      icon={<InfoCircleOutlined />}
                                      type="link"
                                    ></Button>
                                  }
                                ></CriteriaFormModal>
                              </div>
                            </Col>
                          </Row>
                        }
                      ></List.Item.Meta>
                    </List.Item>
                  );
                }}
              ></List>
            );
          }}
        </Form.List>
      </Form>
    </TemplateFormContext.Provider>
  );
};
export { TemplateForm, TemplateEditMode };
